import React from "react";
import Signup from "../Components/SignIN_SignUP/Sign_UP";
function SignUP() {
  return <Signup />;
}

export default SignUP;
